import { Button, Typography } from "@mui/material";

export const STATUS_CONSULTA = {
  1: "Agendada",
  2: "Em andamento",
  3: "Finalizada",
  4: "Cancelada",
};

export function cardColor(type) {
  switch (type) {
    case "Fonoaudiologia":
      return "#D85050";
    case "Psicologia":
      return "#7AABC5";
    case "Neurologia":
      return "#A254DF";
    case "Multidisplinar":
      return "#1E729F";
    case "Nutrição":
      return "#65C94D";
    case "Fisioterapia":
      return "#FE9647";
    default:
      return "#F5F5F5";
  }
}
export function TagAgendamentos({ start, end, type, onClick, status }) {
  var timeEnd = 30;
  const isNotValid = end === "" || end === null || end === undefined;
  if (isNotValid) {
    const [hour, minute] = start.split(":");
    const totalTime = parseInt(hour) * 60 + parseInt(minute) + timeEnd;
    const totalHours = Math.floor(totalTime / 60);
    const totalMinutes = totalTime % 60;
    timeEnd = `${String(totalHours).padStart(2, "0")}:${String(
      totalMinutes
    ).padStart(2, "0")}`;
  }

  return (
    <Button
      size="small"
      sx={{
        color: cardColor(type),
        borderColor: cardColor(type),
        fontSize: "14px",
        borderLeft: "5px solid",
        borderRadius: "5px",
        backgroundColor: "#EFF5F7",
        minHeight: "50px",
        display: "flex",
        flexDirection: "column",
        textAlign: "start",
        padding: "8px",
        textTransform: "capitalize",
      }}
      onClick={onClick}
    >
      {start} - {isNotValid ? timeEnd : end} <br />
      {type}
      <br />
      <Typography component={"span"} variant="caption" fontWeight={700}>
        {STATUS_CONSULTA[status]}
      </Typography>
    </Button>
  );
}
